import { useWalletStore } from '../store/walletStore';

export function BalancePill() {
  const balance = useWalletStore((s) => s.balance);
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-felt-dark px-3 py-1 text-sm font-semibold text-gold">
      <span aria-hidden>🪙</span>
      {balance === null ? '—' : balance.toLocaleString()}
    </span>
  );
}
